import cn from 'classnames'
import css from 'dom-helpers/css'
import getHeight from 'dom-helpers/height'
import transitionEnd from 'dom-helpers/transitionEnd'
import * as React from 'react'
import { Transition, TransitionStatus } from './Transition'

const transitionClasses: Partial<Record<TransitionStatus, string | undefined>> = {
  "entering": 'rw-slide-transition-entering',
  "exiting": 'rw-slide-transition-exiting',
  "exited": 'rw-slide-transition-exited',
};

export interface SlideDownTransitionProps {
  in: boolean
  innerClassName?: string
  dropUp?: boolean
  onExit?: () => void
  onExited?: () => void
  onEntering?: () => void
  onEntered?: () => void
  className?: string
  children: React.ReactElement<{ className?: string }>
}

class SlideDownTransition extends React.Component<SlideDownTransitionProps> {

  nodeRef = React.createRef<HTMLElement>()

  getHeight(container: HTMLElement) {
    let content = container.firstChild as HTMLElement
    let margin =
      parseInt(css(content, 'margin-top') as string, 10) +
      parseInt(css(content, 'margin-bottom') as string, 10)

    let old = container.style.display
    let height

    container.style.display = 'block'
    height = (getHeight(content) || 0) + (isNaN(margin) ? 0 : margin)
    container.style.display = old
    return height
  }

  setContainerHeight = () => {
    this.nodeRef.current!.style.height =
      this.getHeight(this.nodeRef.current!) + 'px'
  }

  clearContainerHeight = (elem: HTMLElement) => {
    elem.style.height = ''
  }

  handleEntered = () => {
    this.clearContainerHeight(this.nodeRef.current!)

    if (this.props.onEntered) this.props.onEntered()
  }

  handleEntering = () => {
    if (this.props.onEntering) this.props.onEntering()
  }

  handleExit = () => {
    this.setContainerHeight()

    if (this.props.onExit) this.props.onExit()
  }
  handleExited = () => {
    this.clearContainerHeight(this.nodeRef.current!)

    if (this.props.onExited) this.props.onExited()
  }

  handleTransitionEnd = (_: HTMLElement, done: () => void) => {
    transitionEnd(this.nodeRef.current!.firstChild as HTMLElement, done)
  }

  render() {
    const { children, className, dropUp, ...props } = this.props

    return (
      <Transition
        appear
        in={this.props.in}
        nodeRef={this.nodeRef}
        onEnter={this.setContainerHeight}
        onEntering={this.handleEntering}
        onEntered={this.handleEntered}
        onExit={this.handleExit}
        onExited={this.handleExited}
        addEndListener={this.handleTransitionEnd}
        timeout={undefined as any /*hack*/}
      >
        {(status: TransitionStatus) => (
          <div
            {...props}
            ref={this.nodeRef as React.RefObject<HTMLDivElement>}
            className={cn(
              className,
              dropUp && 'rw-dropup',
              (transitionClasses as any)[status],
            )}
          >
            {React.cloneElement(children, {
              className: cn(
                'rw-slide-transition',
                children.props.className,
              ),
            })}
          </div>
        )}
      </Transition>
    )
  }
}

export default SlideDownTransition
